// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:stores` (see frontend/package.json).
// Source: agent.shared.types.prompt_event.PromptEvent

import { makeObservable, observable } from "mobx";
import { applyJsonPatch, JsonPatchOp } from "@/app_store/rpc/json_patch";
import { AgentTransport, callRpc } from "@/app_store/rpc/rpc";
import { registerEntity, wrapEntity } from "@/app_store/rpc/entity";
import { PromptEventType } from "./PromptEventType.generated";

export interface PromptEventData {
    // Stamped onto every @observable model's dump at runtime (see
    // common._ObservableMixin._serialize_with_tag) -- tells wrapEntity which
    // generated Store class this value belongs to. Never sent by a client.
    _entity_class_name: "PromptEvent";
    type: PromptEventType;
    content: string;
    tool_name: string;
    tool_input: Record<string, unknown>;
    source: string;
    path: string;
    event_id: string;
    command: string;
    explanation: string;
    event_datetime: string;
}

export class PromptEventStore {
    readonly _entity_class_name = "PromptEvent" as const;
    type: PromptEventType;
    content: string;
    tool_name: string;
    tool_input: Record<string, unknown>;
    source: string;
    path: string;
    event_id: string;
    command: string;
    explanation: string;
    event_datetime: string;
    private _transport: AgentTransport;
    private _chainPath: string[];

    constructor(data: PromptEventData, transport: AgentTransport, chainPath: string[] = []) {
        this._transport = transport;
        this._chainPath = chainPath;
        this.type = wrapEntity(data.type, transport, [...chainPath, "type"]);
        this.content = wrapEntity(data.content, transport, [...chainPath, "content"]);
        this.tool_name = wrapEntity(data.tool_name, transport, [...chainPath, "tool_name"]);
        this.tool_input = wrapEntity(data.tool_input, transport, [...chainPath, "tool_input"]);
        this.source = wrapEntity(data.source, transport, [...chainPath, "source"]);
        this.path = wrapEntity(data.path, transport, [...chainPath, "path"]);
        this.event_id = wrapEntity(data.event_id, transport, [...chainPath, "event_id"]);
        this.command = wrapEntity(data.command, transport, [...chainPath, "command"]);
        this.explanation = wrapEntity(data.explanation, transport, [...chainPath, "explanation"]);
        this.event_datetime = wrapEntity(data.event_datetime, transport, [...chainPath, "event_datetime"]);
        makeObservable(this, {
            type: observable,
            content: observable,
            tool_name: observable,
            tool_input: observable,
            source: observable,
            path: observable,
            event_id: observable,
            command: observable,
            explanation: observable,
            event_datetime: observable,
        });
    }

    applyPatch(op: JsonPatchOp): void {
        applyJsonPatch(this, op);
    }
}

registerEntity("PromptEvent", PromptEventStore);
